import { SubscriptionServiceReplyJSON } from './types/jsons/SubscriptionServiceReplyJSON'
import { fetchSubscriptionServiceUrl } from './fetchSubscriptionServiceUrl'

const getClaimFreeMonthUrl = (subscriptionId: string): string =>
  `/v2/subscriptions/${subscriptionId}/claim-free-month`

export interface ClaimFreeMonthSubscriptionOptions {
  token: string
  subscriptionId: string
}

/**
 * Calls the subscription service PUT /subscriptions endpoint to claim
 * a free month on their subscription (if eligible).
 *
 * Intended to help reduce churn when people start to cancel or downgrade.
 *
 * May be used as a fetcher for useSWR or by itself for SSR.
 *
 * @docs https://github.com/dtx-company/subscription-service/blob/trunk/docs/put-subscriptions.md#claimfreemonth-schema
 */
export async function claimFreeMonthSubscription(
  options: ClaimFreeMonthSubscriptionOptions
): Promise<void> {
  const { subscriptionId, token } = options
  const url = getClaimFreeMonthUrl(subscriptionId)
  const response = await fetchSubscriptionServiceUrl<SubscriptionServiceReplyJSON>({
    method: 'POST',
    token,
    url
  })
  if (!response.ok) {
    throw new Error(`Received http status ${response.status} from /subscriptions endpoint`)
  }
}
